export default __webpack_public_path__ + "static/media/IMG7807.522efa7f.jpg";